import { Box, Typography } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";
import { DossierDataToUpdate } from "../../../../types";
import ReactSvgIcon from "../../../UIElements/ReactSvgIcon";
import { ReactComponent as CircleCheckIcon } from "../../../../public/icons/CircleCheckIcon.svg";
import { useFetch } from "../../../../hooks";

export default function SendDossierToSynerpaModalContent({
    dataDossier,
    onSubmit,
}: {
    dataDossier: DossierDataToUpdate;
    onSubmit: Function;
}) {
    const { fetcher } = useFetch();
    const textStepsOk =
        "un ou plusieurs documents ne sont pas conformes, le dossier retourne chez le client.";
    let iconRes = false ? (
        <ReactSvgIcon
            width="1.5rem"
            height="1.5rem"
            ReactIcon={CircleCheckIcon}
        />
    ) : (
        <></>
    ); //on attend les icons pour fixe ca.
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "1.25rem",
                    alignSelf: "stretch",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1.25rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "var(--Generiques-Dark-Blue-1, #023)",
                                fontFamily: "Roboto",
                                fontSize: "1.25rem",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "normal",
                            }}
                        >
                            Soumettre un avis
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "1rem",
                                alignSelf: "stretch",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "var(--Generiques-Dark-Blue-1, #023)",
                                    fontFamily: "Roboto",
                                    fontSize: "0.875rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "1.25rem",
                                }}
                            >
                                Le dossier est retransmis au client pour qu'il
                                corrige les documents non conformes.
                                <Typography
                                    sx={{
                                        color: "var(--Generiques-Dark-Blue-1, #023)",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: "700",
                                        lineHeight: "1.25rem",
                                    }}
                                >
                                    {" "}
                                    Le dossier reste modifiable.
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            padding: "1rem",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.75rem",
                            alignSelf: "stretch",
                            borderRadius: "0.75rem",
                            border: "1px solid var(--Socotec-Socotec-Dark-Blue, #005499)",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.75rem",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                }}
                            >
                                {iconRes}
                                <Typography
                                    sx={{
                                        color: "var(--Socotec-Socotec-Dark-Blue, #005499)",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                        lineHeight: "normal",
                                    }}
                                >
                                    {textStepsOk}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1rem",
                    alignSelf: "stretch",
                }}
            >
                <CustomButton
                    onClick={async () => {
                        fetcher(onSubmit(dataDossier));
                    }}
                    label="Validez l'avis"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </Box>
        </Box>
    );
}
